
import { searchQueryService } from "./searchQueryService";
import { searchMutationService } from "./searchMutationService";

// Export individual services
export { searchQueryService } from "./searchQueryService";
export { searchMutationService } from "./searchMutationService";

/**
 * Consolidated search service that combines query and mutation services
 */
export const searchService = {
  // Query methods
  getRecentSearches: searchQueryService.getRecentSearches,
  
  // Mutation methods
  saveSearch: searchMutationService.saveSearch,
};

// Export default for consistency with other service modules
export default searchService;
